<script>
    import {onMount} from "svelte";
    import {API_URL} from "../../../../env";
    import {showDialogLogin} from "../../../js/stores";
    import {querystring} from "svelte-spa-router";

    window.scrollTo(0, 0);

    onMount(async () => {
        const urlParams = new URLSearchParams($querystring)

        setTimeout(async () => {
            if (!urlParams.has("t")) {
                return showDialogLogin.set({show: true, type: "error", data: {
                        title: "Nie je možné overiť žiadny účet, chýba overovací token.",
                        text: ''
                    }})
            }

            const body = {
                token: urlParams.get("t")
            }

            const res = await fetch(API_URL+'/users/verify', {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })

            if (res.status === 200) {
                return showDialogLogin.set({show: true, type: "check", data: {
                        title: "Účet úspešne overený.",
                        text: 'Teraz sa môžete <a data-modal="login">prihlásiť</a>.'
                    }})
            }
            else if (res.status === 202) {
                return showDialogLogin.set({show: true, type: "check", data: {
                        title: "Účet už je overený.",
                        text: 'Skúste sa <a data-modal="login">prihlásiť</a>.'
                    }})
            }
            else {
                return showDialogLogin.set({show: true, type: "error", data: {
                        title: "Niekde nastala chyba.",
                        text: 'Táto chyba môže byť spôsobená vypršaním časového limitu tohto odkazu. Pre obdržanie nového odkazu sa <a data-modal="login">prihláste</a> a postupujte podľa následne zobrazených pokynov.'
                    }})
            }
        }, 500)
    })

    function handleOpenLogin() {
        showDialogLogin.set({show: true, type: "login", data: {}})
    }
</script>

<div class="loading-page">
    <i class="far fa-tire fa-spin"></i>
    <h3>Načítavam...</h3>
</div>
